import { sharedSelectors, userSelectors } from 'shared-lib'

export const selectors = { ...sharedSelectors, ...userSelectors }
